"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoofProLogo = exports.RoofProLabel = exports.CompanyLogo = exports.Title = exports.Details = exports.Address = exports.Item = exports.StyledCard = exports.classes = void 0;
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const styles_1 = require("@mui/material/styles");
const card_1 = __importDefault(require("../card"));
const typography_1 = __importDefault(require("../typography"));
const logo_1 = __importDefault(require("../logo"));
const PREFIX = "LinkCard";
exports.classes = {
    open: `${PREFIX}-open`,
    icon: `${PREFIX}-icon`
};
exports.StyledCard = (0, styles_1.styled)(card_1.default)(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    boxShadow: "none",
    backgroundColor: theme.colours.white,
    color: theme.colours.slate,
    padding: "16px",
    borderRadius: "0%",
    cursor: "pointer",
    [theme.breakpoints.up("lg")]: {
        border: `1px solid ${theme.colours.storm}`,
        marginTop: "-1px",
        "&:hover": {
            color: theme.colours.charcoal,
            backgroundColor: theme.colours.pearl,
            [`.${exports.classes.icon}`]: {
                color: `${theme.colours.black}59`
            }
        }
    },
    "& + &": {
        borderTop: `1px solid ${theme.colours.storm}`
    },
    [`&.${exports.classes.open}`]: {
        [theme.breakpoints.up("lg")]: {
            backgroundColor: theme.colours.alabaster,
            color: theme.colours.charcoal
        },
        [`.${exports.classes.icon}`]: {
            "& svg": {
                color: theme.colours.inter,
                transform: "rotate(-90deg)",
                transition: "transform ease-in-out 280ms, color ease-in-out 280ms",
                [theme.breakpoints.up("lg")]: {
                    color: `${theme.colours.black}33`
                }
            },
            [theme.breakpoints.up("lg")]: {
                "& svg": {
                    transform: "none"
                }
            }
        }
    },
    [`.${exports.classes.icon}`]: {
        height: "24px",
        width: "24px",
        margin: "12px",
        color: `${theme.colours.black}33`,
        flex: "0 1",
        "& svg": {
            transform: "rotate(90deg)",
            transition: "transform ease-in-out 280ms, color ease-in-out 280ms",
            [theme.breakpoints.up("lg")]: {
                transform: "none"
            }
        }
    }
}));
exports.Item = (0, styles_1.styled)("div")({ flex: "2 0" });
exports.Address = (0, styles_1.styled)(typography_1.default)({
    fontSize: "16px",
    lineHeight: 1.2,
    fontStyle: "unset"
});
exports.Details = (0, styles_1.styled)(Collapse_1.default)(({ theme }) => ({
    flex: "3 0 100%",
    [theme.breakpoints.up("lg")]: {
        display: "none"
    }
}));
exports.Title = (0, styles_1.styled)(typography_1.default)({
    marginBottom: "16px"
});
exports.CompanyLogo = (0, styles_1.styled)("div")({
    marginBottom: "18px",
    height: "40px",
    maxWidth: "91px",
    img: {
        height: "40px"
    }
});
exports.RoofProLabel = (0, styles_1.styled)(typography_1.default)({
    marginTop: "1rem"
});
exports.RoofProLogo = (0, styles_1.styled)(logo_1.default)({
    height: "18px",
    verticalAlign: "middle"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xpbmstY2FyZC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsc0VBQThDO0FBQzlDLGlEQUE4QztBQUM5QyxtREFBMkI7QUFDM0IsK0RBQXVDO0FBQ3ZDLG1EQUEyQjtBQUUzQixNQUFNLE1BQU0sR0FBRyxVQUFVLENBQUM7QUFFYixRQUFBLE9BQU8sR0FBRztJQUNyQixJQUFJLEVBQUUsR0FBRyxNQUFNLE9BQU87SUFDdEIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0NBQ3ZCLENBQUM7QUFFVyxRQUFBLFVBQVUsR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDckQsT0FBTyxFQUFFLE1BQU07SUFDZixRQUFRLEVBQUUsTUFBTTtJQUNoQixTQUFTLEVBQUUsTUFBTTtJQUNqQixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0lBQ3BDLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDMUIsT0FBTyxFQUFFLE1BQU07SUFDZixZQUFZLEVBQUUsSUFBSTtJQUNsQixNQUFNLEVBQUUsU0FBUztJQUNqQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsTUFBTSxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUU7UUFDMUMsU0FBUyxFQUFFLE1BQU07UUFDakIsU0FBUyxFQUFFO1lBQ1QsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtZQUM3QixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1lBQ3BDLENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtnQkFDcEIsS0FBSyxFQUFFLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLElBQUk7YUFDbEM7U0FDRjtLQUNGO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsU0FBUyxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUU7S0FDOUM7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDckIsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1lBQzVCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLFNBQVM7WUFDeEMsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtTQUM5QjtRQUNELENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUNwQixPQUFPLEVBQUU7Z0JBQ1AsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztnQkFDMUIsU0FBUyxFQUFFLGdCQUFnQjtnQkFDM0IsVUFBVSxFQUFFLHNEQUFzRDtnQkFDbEUsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO29CQUM1QixLQUFLLEVBQUUsR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssSUFBSTtpQkFDbEM7YUFDRjtZQUNELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtnQkFDNUIsT0FBTyxFQUFFO29CQUNQLFNBQVMsRUFBRSxNQUFNO2lCQUNsQjthQUNGO1NBQ0Y7S0FDRjtJQUNELENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUNwQixNQUFNLEVBQUUsTUFBTTtRQUNkLEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07UUFDZCxLQUFLLEVBQUUsR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssSUFBSTtRQUNqQyxJQUFJLEVBQUUsS0FBSztRQUNYLE9BQU8sRUFBRTtZQUNQLFNBQVMsRUFBRSxlQUFlO1lBQzFCLFVBQVUsRUFBRSxzREFBc0Q7WUFDbEUsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO2dCQUM1QixTQUFTLEVBQUUsTUFBTTthQUNsQjtTQUNGO0tBQ0Y7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7QUFFdEMsUUFBQSxPQUFPLEdBQUcsSUFBQSxlQUFNLEVBQUMsb0JBQVUsQ0FBQyxDQUFDO0lBQ3hDLFFBQVEsRUFBRSxNQUFNO0lBQ2hCLFVBQVUsRUFBRSxHQUFHO0lBQ2YsU0FBUyxFQUFFLE9BQU87Q0FDbkIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxPQUFPLEdBQUcsSUFBQSxlQUFNLEVBQUMsa0JBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN0RCxJQUFJLEVBQUUsVUFBVTtJQUNoQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsT0FBTyxFQUFFLE1BQU07S0FDaEI7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsS0FBSyxHQUFHLElBQUEsZUFBTSxFQUFDLG9CQUFVLENBQUMsQ0FBQztJQUN0QyxZQUFZLEVBQUUsTUFBTTtDQUNyQixDQUFDLENBQUM7QUFFVSxRQUFBLFdBQVcsR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUN2QyxZQUFZLEVBQUUsTUFBTTtJQUNwQixNQUFNLEVBQUUsTUFBTTtJQUNkLFFBQVEsRUFBRSxNQUFNO0lBQ2hCLEdBQUcsRUFBRTtRQUNILE1BQU0sRUFBRSxNQUFNO0tBQ2Y7Q0FDRixDQUFDLENBQUM7QUFFVSxRQUFBLFlBQVksR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUM7SUFDN0MsU0FBUyxFQUFFLE1BQU07Q0FDbEIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxXQUFXLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBSSxDQUFDLENBQUM7SUFDdEMsTUFBTSxFQUFFLE1BQU07SUFDZCxhQUFhLEVBQUUsUUFBUTtDQUN4QixDQUFDLENBQUMifQ==